import marinaAPI from "../../services/marinaAPI";

const appError = {
  applicationError: {
    hasError: false,
    error: [
      " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};

export default {
  healthCheck: ({ commit }) => {
    try {
      marinaAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  postMarinaInfo: ({ commit }, { formData, nextStep }) => {
    try {
      marinaAPI
        .postMarinaInfo(formData)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            if (response.data.Success) {
              commit("setReferenceNumber", response.data.ReferenceNumber);
              nextStep();
            }
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.errors
          ) {
            let formattedErrors = [];
            (Object.values(err.response.data.errors) || []).map(error => {
              if (Array.isArray(error)) {
                formattedErrors.push(...error);
              } else {
                formattedErrors.push(error);
              }
            });
            commit("setErrors", {
              createMarinaFormError: {
                hasError: true,
                error: formattedErrors
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  }
};
